import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { DepositQRCodeCopiedStyled } from "./styled/DepositQRCodeCopiedStyled";

function DepositQRCodeCopiedNotification() {
    const {getLangPath} = useLangContext();

    return <DepositQRCodeCopiedStyled>
        <h3>{getLangPath('deposit.key_copied')}</h3>
        <p>{getLangPath('deposit.paste_key_into_app')}</p>
    </DepositQRCodeCopiedStyled>
}

export default DepositQRCodeCopiedNotification;
